import React from 'react';
import { arrayOf, string } from 'prop-types';

export const WhatToExpect = ({ whatToExpectList }) => {
  if (!whatToExpectList?.length) {
    return null;
  }

  return (
    <ul className="sui-ml-6 sui-list-disc sui-text-sm">
      {whatToExpectList.map((item, index) => (
        <li className="sui-font-regular sui-text-sm sui-leading-10" key={index}>
          {item}
        </li>
      ))}
    </ul>
  );
};

WhatToExpect.propTypes = {
  whatToExpectList: arrayOf(string)
};

WhatToExpect.defaultProps = {
  whatToExpectList: []
};